
import { dispatcher } from '../dispatcher/dispatcher';
import Constants from '../constants/constants';
import { storeUtils } from './util';
const { ActionTypes } = Constants;
var _events = new storeUtils.EventEmitter();
var CHANGE_EVENT = 'change';

//the entire list of subdivisions as loaded from the server
var _subdivisionsList;
//the list of subs that are related to the selected sub, the subs that are displayed
var _selectableSubs = [];
//the selected subdivision
var _selectedSubdivision = 0;
//all the data about this subdivision
var _subdivisionData;
//flag determining if a sub is selected
var _subSelected = false;

var dispatchToken = dispatcher.register(function (action) {
    //this action comes from the dispatcher
    switch (action.type) {
        //initial load of list from server
        case ActionTypes.SUBDIVISION_LIST_LOADED:
            //trim the list the first time just in case
            _subdivisionsList = action.subs;
            _selectableSubs = action.subs;
            _events.trigger(CHANGE_EVENT);
            break;

        case ActionTypes.COMPARE_SUBDIVISION_CHANGED:
        case ActionTypes.COMPARE_GIS_ENVIRONMENT_CHANGED:
            _subdivisionData = { "defaultDirection": "", "defaultTimezone": "", "fullName": "", "milePostRangeList": [], "name": "", "usesGTB": true };
            _selectedSubdivision = action.selectedSub;
            _subSelected = true;

            _events.trigger(CHANGE_EVENT);
            break;

        case ActionTypes.SUBDIVISION_DETAILS_LOADED:
            _subdivisionData = action.details;
            _events.trigger(CHANGE_EVENT);
            break;

        default:
        //no op
    }
});//end of dispatch token

//public api
export const compareSubdivisionStore = {
    dispatchToken,
    subscribe: _events.on,
    unsubscribe: _events.off,
    getSelectedSub: function () { return _selectedSubdivision; },
    getSubList: function () { return _selectableSubs; },
    getEntireSubList: function () { return _subdivisionsList; },
    getSubData: function () { return _subdivisionData; },
    isSubSelected: function () { return _subSelected; }
};
